module.exports = __webpack_public_path__ + "img/8.e1cde102.jpeg";